import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { extendedStyles } from "@insite/content-library/Widgets/CompactHeader/Logo";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import { statusStyles } from "@store/Themes/common/mixins/status";
import { productLineProps } from "@store/Themes/common/props/productLine";
import React, { useState } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

interface OwnProps {
    product?: ProductModel;
    cartLine?: CartLineModel;
    productInfo?: ProductInfo;
    extendedStyles?: PromoTagStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    productInfosById: state.pages.productDetails.productInfosById,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface PromoTagStyles {
    promoTagContent?: TypographyPresentationProps;
    promoTagWrapper?: InjectableCss;
}

export const promoTagStyles: PromoTagStyles = {
    promoTagContent: {
        css: css`
            position: relative;
            width: 2.5em;
            height: 4em;
            padding-top: 1em;
            margin-top: -0.3125rem;
            background-color: ${getColor("secondary.main")};
            text-align: center;

            &::before {
                position: absolute;
                top: 0;
                right: -0.3125rem;
                content: "";
                width: 0;
                height: 0;
                border-right: 0.3125rem solid transparent;
                border-bottom: 0.4375rem solid ${getColor("text.main")};
            }
        `,
    },
    promoTagWrapper: {
        css: css`
            position: absolute;
            top: 0;
            right: 1em;
            z-index: 1;
        `,
    },
};

const PromoTag = ({ product, cartLine, productInfo, productInfosById }: Props) => {
    const [styles] = useState(() => mergeToNew(promoTagStyles, extendedStyles));
    let canDisplaySalesFlag = false;
    if (cartLine && cartLine.pricing) {
        canDisplaySalesFlag =
            cartLine.pricing.isOnSale && cartLine.pricing.unitListPrice !== cartLine.pricing.unitRegularPrice;
    } else if (product || productInfosById || productInfo) {
        let currentProductInfo = productInfo;
        if (!currentProductInfo && productInfosById && product && productInfosById[product?.id]) {
            currentProductInfo = productInfosById[product?.id];
        }
        if (!currentProductInfo) {
            return null;
        }
        if (currentProductInfo && currentProductInfo.pricing) {
            canDisplaySalesFlag =
                currentProductInfo.pricing.isOnSale &&
                currentProductInfo.pricing.unitListPrice !== currentProductInfo.pricing.unitRegularPrice;
        }
    }

    if (!canDisplaySalesFlag) {
        return null;
    }

    return (
        <StyledWrapper {...styles.promoTagWrapper}>
            <StyledWrapper {...styles.promoTagContent}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path
                        fill="#fff"
                        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                    ></path>
                </svg>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(PromoTag);
